import request from '@/utils/request'
const apiPath = '/course/courseClassification'
import { downloadBlob } from '@/utils/download'
const courseClassificationApi = {
  /**
   * 新增【课程分类】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【课程分类】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【课程分类】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  getClassificationCourseSubject(query) {
    return request.get(`${apiPath}/getClassificationCourseSubject`, { params: query })
  },
  /**
   * 查看【课程分类】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【课程分类】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  batchState(data) {
    return request.post(apiPath + '/batchState', data, { isFormData: 1 })
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '课程分类.xlsx'))
  },
  courseImport(data) {
    return request.post(apiPath + '/import', data)
  },
}
export default courseClassificationApi
